<template>
  <div style="height: 100%;">
    <el-table class="import-table" :data="table" border
              style="width: 100%;margin-top: 20px;"
              height="calc(100% - 140px)">
      <el-table-column type="index" label="序号"/>
      <el-table-column label="月份" show-overflow-tooltip>
        <template v-slot="{row:{date_live}}">
          {{ date_live|parseTime('{y}年{m}月') }}
        </template>
      </el-table-column>
      <el-table-column prop="platform" label="平台" show-overflow-tooltip/>
      <el-table-column prop="artist_no" label="红人账号" show-overflow-tooltip/>
      <el-table-column prop="artist_name" label="红人" show-overflow-tooltip/>
      <el-table-column prop="product_name" label="产品" show-overflow-tooltip/>
      <el-table-column prop="source_traffic" label="流量来源"/>
      <el-table-column prop="shop_name" label="店铺" show-overflow-tooltip/>
      <el-table-column label="销量" align="right">
        <template v-slot="{row:{sales_volume}}">
          {{ sales_volume|numberFormat(2) }}
        </template>
      </el-table-column>
      <el-table-column label="结算金额" align="right">
        <template v-slot="{row:{settlement_amount}}">
          {{ settlement_amount|numberFormat(2) }}
        </template>
      </el-table-column>
      <el-table-column label="佣金收入" align="right">
        <template v-slot="{row:{commission_income}}">
          {{ commission_income|numberFormat(2) }}
        </template>
      </el-table-column>
      <el-table-column label="佣金比例" align="right">
        <template v-slot="{row:{commission_rate}}">
          {{ commission_rate|numberFormat(2) }}%
        </template>
      </el-table-column>
    </el-table>
    <div
        style="display: flex;justify-content: space-between;align-items: center;padding: 8px 0;margin-top: 4px;">
      <div style="color: #3c3c3c">
        <span style="margin-right: 10px;">
          总结算金额：<b>￥{{ total_settlement_amount|numberFormat(2) }}</b>
        </span>
        <span>
          总佣金收入：<b>￥{{ total_commission_income|numberFormat(2) }}</b>
        </span>
      </div>
      <el-pagination
          :current-page.sync="page"
          :page-size="20"
          :pager-count="5"
          layout="total, prev, pager, next"
          :total="list.length"
      />
    </div>
  </div>
</template>
<script>
export default {
  name: "importTable",
  props: ['list', 'total_settlement_amount', 'total_commission_income'],
  data() {
    return {
      page: 1,
      table: [],
    }
  },
  watch: {
    page: {
      immediate: true,
      handler() {
        this.getPageData()
      }
    }
  },
  methods: {
    getPageData: function () {
      this.table = []
      if (!Array.isArray(this.list)) {
        return
      }
      const page = this.page
      const start = (page - 1) * 20
      const end = (page) * 20
      this.table = this.list.slice(start, end)
    },
  }
}
</script>
<style scoped>

</style>
